export async function updateScore({
  sessionId,
  organizationId,
  users,
  role,
  token,
  gameId,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateScore`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({
      sessionId,
      organizationId,
      users,
      role,
      token,
      gameId,
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to update score");
  }
  return data;
}
